module.exports = __webpack_public_path__ + "img/logo.736bc61a.png";